import { differenceInDays } from 'date-fns';
import config from '../config/maintenance-config.json';

export const getDismissalFromStorage = (): boolean => {
  const rawDismissalDate = localStorage.getItem(config.localStorageKey);
  if (!rawDismissalDate) {
    return false;
  }

  try {
    const dismissalDate = new Date(rawDismissalDate);
    const diffInDays = differenceInDays(new Date(), dismissalDate);
    return diffInDays < config.dismissalRelevantInDays;
  } catch {
    // ignore error here - means we got a corrupted value from local-storage
    // no need to log
    return false;
  }
};

export const setDismissalToStorage = () => {
  localStorage.setItem(config.localStorageKey, new Date().toISOString());
};
